import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Pagination, PaginationItem } from "@mui/material";
import { type ReactNode, useEffect, useMemo, useState } from "react";

export function PaginationWrapper<T extends { [key: string]: unknown }[]>({
  data,
  renderPage,
  itemsPerPage,
}: {
  data: T;
  renderPage: (data: T) => ReactNode;
  itemsPerPage: number;
}): ReactNode {
  const [page, setPage] = useState(1);

  useEffect(() => {
    // Always set the page back to one if the assets change
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPage(1);
  }, [data]);

  const pagedData = useMemo(() => {
    const startIndex = (page - 1) * itemsPerPage;
    return data.slice(startIndex, startIndex + itemsPerPage) as T;
  }, [data, page, itemsPerPage]);

  return (
    <>
      {renderPage(pagedData)}
      <Box
        alignItems="center"
        sx={{
          p: 2,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Pagination
          renderItem={(item) => (
            <PaginationItem
              data-testid={item.type === "page" ? `pagination-page-${item.page}` : undefined}
              slots={{ previous: ArrowBack, next: ArrowForward }}
              {...item}
            />
          )}
          count={Math.ceil(data.length / itemsPerPage)}
          page={page}
          onChange={(_, pageNum) => {
            setPage(pageNum);
          }}
        />
      </Box>
    </>
  );
}
